
export const storeQuestionAlternative = async (resource,data) => {
    let alternative;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/question_alternative`,data)
      .then(
        (response) => {
          console.log(response);
          alternative = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return alternative;
}
  